import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 p-4 md:p-8 safe-left safe-right safe-bottom"
      style={{ paddingTop: 'calc(var(--app-safe-area-top) + 1rem)' }}
    >
      <div className="mx-auto max-w-4xl">
        <div className="comic-card space-y-8">
          <header className="space-y-3">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
              Privacy Policy
            </h1>
            <p className="text-sm text-gray-600">
              Effective date: March 1, 2026
            </p>
            <p className="text-gray-700">
              This Privacy Policy explains how Okio ("we", "us", or "our")
              collects, uses, shares, and protects your personal information
              when you use our web and mobile applications.
            </p>
          </header>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-gray-900">
              Information We Collect
            </h2>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              <li>
                <strong>Account information:</strong> name, username, email
                address, and authentication details.
              </li>
              <li>
                <strong>Content you provide:</strong> projects, messages,
                uploads, and other information you submit in the app.
              </li>
              <li>
                <strong>Device and usage data:</strong> app logs, device type,
                operating system, app version, and interaction data.
              </li>
              <li>
                <strong>Location data:</strong> precise or approximate location
                only when you grant permission and features require it.
              </li>
              <li>
                <strong>Push notification tokens:</strong> used to send
                notification messages you opt in to receive.
              </li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-gray-900">
              How We Use Information
            </h2>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              <li>Provide, maintain, and improve app functionality.</li>
              <li>Authenticate users and secure accounts.</li>
              <li>Enable collaboration and core product features.</li>
              <li>Send service-related messages and notifications.</li>
              <li>
                Monitor performance, troubleshoot issues, and prevent abuse.
              </li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-gray-900">
              Sharing of Information
            </h2>
            <p className="text-gray-700">
              We do not sell your personal information. We may share
              information with:
            </p>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              <li>
                Service providers who help us operate infrastructure, analytics,
                authentication, and notifications.
              </li>
              <li>
                Other users, based on the content and visibility settings you
                choose.
              </li>
              <li>
                Authorities or other parties when required by law or to protect
                rights, safety, and security.
              </li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-gray-900">
              Data Retention
            </h2>
            <p className="text-gray-700">
              We retain personal information as long as needed to provide the
              service, comply with legal obligations, resolve disputes, and
              enforce agreements.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-gray-900">
              Security
            </h2>
            <p className="text-gray-700">
              We use technical and organizational safeguards designed to protect
              your data. No method of transmission or storage is completely
              secure, so we cannot guarantee absolute security.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-gray-900">
              Children&apos;s Privacy
            </h2>
            <p className="text-gray-700">
              Our services are not directed to children under 13, and we do not
              knowingly collect personal information from children under 13.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-gray-900">
              Your Choices and Rights
            </h2>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              <li>
                You can access, correct, or delete certain account information.
              </li>
              <li>
                You can manage permission settings (such as location and
                notifications) in your device and browser settings.
              </li>
              <li>
                You can request account deletion or data-related support by
                contacting us.
              </li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-gray-900">Contact Us</h2>
            <p className="text-gray-700">
              If you have questions about this Privacy Policy, contact us at{' '}
              <a
                className="text-purple-700 hover:underline"
                href="mailto:admin@okio.ai"
              >
                admin@okio.ai
              </a>
              .
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-gray-900">
              Changes to This Policy
            </h2>
            <p className="text-gray-700">
              We may update this Privacy Policy from time to time. We will post
              any updates on this page and revise the effective date above.
            </p>
          </section>

          <div>
            <Link to="/" className="btn-secondary inline-flex items-center">
              Back to app
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
